// extracted by mini-css-extract-plugin
module.exports = {"componentHolder":"AddTitleMenu_componentHolder__Cbued"};